boardFieldsMinimal = [
  'name'
  'closed'
  'dateLastActivity'
  'dateLastView'
  'datePluginDisable'
  'enterpriseOwned'
  'idOrganization'
  'prefs'
  'premiumFeatures'
  'shortLink'
  'shortUrl'
  'url'
  'creationMethod'
  'idEnterprise'
].join(',')

boardFieldsFull = [
  boardFieldsMinimal
  'desc'
  'descData'
  'idTags'
  'invitations'
  'invited'
  'labelNames'
  'limits'
  'memberships'
  'powerUps'
  'subscribed'
  'templateGallery'
].join(',')

boardFieldsMinimalSubscribed = [
  boardFieldsMinimal
  'subscribed'
].join(',')

memberFields = [
  'avatarUrl'
  'bio'
  'bioData'
  'confirmed'
  'fullName'
  'idEnterprise'
  'idMemberReferrer'
  'initials'
  'memberType'
  'nonPublic'
  'products'
  'url'
  'username'
].join(',')

memberFieldsAndPremOrgsAdmin = [
  memberFields
  'idPremOrgsAdmin'
].join(',')

organizationFieldsMinimal = [
  'name'
  'displayName'
  'products'
  'prefs'
  'logoHash'
  'idEnterprise'
  'tags'
  'limits'
  'allAdminsEnabled'
].join(',')

organizationFieldsMinimalMemberships = [
  organizationFieldsMinimal
  'memberships'
].join(',')

cardFieldsBulk = [
  'badges'
  'closed'
  'dateLastActivity'
  'desc'
  'descData'
  'due'
  'dueComplete'
  'dueReminder'
  'idAttachmentCover'
  'idList'
  'idBoard'
  'idMembers'
  'idShort'
  'idLabels'
  'limits'
  'name'
  'pos'
  'shortUrl'
  'shortLink'
  'subscribed'
  'url'
  'locationName'
  'address'
  'coordinates',
  'cover',
  'isTemplate'
].join(',')

boardFieldsInOrganization = [
  boardFieldsMinimal
  'idTags'
].join(',')

organizationBoardsFields = [
  organizationFieldsMinimal
  'desc'
  'descData'
  'website'
  'limits'
  'billableCollaboratorCount'
].join(',')

cardActions = [
  'addAttachmentToCard'
  'addChecklistToCard'
  'addMemberToCard'
  'commentCard'
  'copyCommentCard'
  'convertToCardFromCheckItem'
  'createCard'
  'copyCard'
  'deleteAttachmentFromCard'
  'emailCard'
  'moveCardFromBoard'
  'moveCardToBoard'
  'removeChecklistFromCard'
  'removeMemberFromCard'
  'updateCard:idList'
  'updateCard:closed'
  'updateCard:due'
  'updateCard:dueComplete'
  'updateCheckItemStateOnCard'
  'updateCustomFieldItem'
].join(',')

boardActions = [
  cardActions
  'addMemberToBoard'
  'addToOrganizationBoard'
  'copyBoard'
  'createBoard'
  'createCustomField'
  'createList'
  'deleteCard'
  'deleteCustomField'
  'disablePlugin'
  'disablePowerUp'
  'enablePlugin'
  'enablePowerUp'
  'makeAdminOfBoard'
  'makeNormalMemberOfBoard'
  'makeObserverOfBoard'
  'moveListFromBoard'
  'moveListToBoard'
  'removeFromOrganizationBoard'
  'unconfirmedBoardInvitation'
  'unconfirmedOrganizationInvitation'
  'updateBoard'
  'updateCustomField'
  'updateList:closed'
].join(',')

card =
  fields: 'all'
  stickers: true
  attachments: true
  customFieldItems: true
  pluginData: true

currentBoardMinimal =
  lists: 'open'
  list_fields: 'name,closed,idBoard,pos,subscribed,limits,creationMethod,softLimit'
  cards: 'visible'
  card_attachments: 'cover'
  card_stickers: true
  card_fields: [cardFieldsBulk, 'labels'].join(',')
  card_checklists: 'none'
  enterprise: true
  enterprise_fields: 'displayName'
  members: 'all'
  member_fields: memberFields
  membersInvited: 'all'
  membersInvited_fields: memberFields
  memberships_orgMemberType: true
  checklists: 'none'
  organization: true
  organization_fields: 'name,displayName,desc,descData,url,website,prefs,memberships,logoHash,products,limits,idEnterprise'
  organization_tags: true
  organization_enterprise: true
  organization_disable_mock: true
  myPrefs: true
  fields: boardFieldsFull

currentBoardSecondary =
  fields: ''
  actions: boardActions
  actions_display: true
  actions_limit: 50
  action_memberCreator_fields: memberFieldsAndPremOrgsAdmin
  action_reactions: true
  checklists: 'none'
  cards: 'visible'
  card_fields: ''
  card_checklists: 'all'
  card_checklist_checkItems: 'none'
  labels: 'all'
  labels_limit: 1000

currentBoardPluginData =
  fields: ''
  boardPlugins: true
  cards: 'visible'
  card_fields: ''
  card_attachments: true
  card_attachment_fields: 'bytes,date,edgeColor,idMember,isUpload,mimeType,name,url'
  card_customFieldItems: true
  customFields: true
  pluginData: true
  card_pluginData: true
  organization: true
  organization_fields: ''
  organization_pluginData: true

memberBoards =
  boards: 'open,starred'
  board_fields: boardFieldsMinimalSubscribed
  boardStars: true
  boardsInvited: 'all'
  boardsInvited_fields: boardFieldsMinimalSubscribed
  board_organization: true
  board_organization_fields: organizationFieldsMinimal
  credits: 'invitation,promoCode'
  organizations: 'all'
  organization_fields: organizationFieldsMinimalMemberships
  organizationsInvited: 'all'
  organizationsInvited_fields: organizationFieldsMinimal
  paid_account: true

memberHeader =
  campaigns: true
  channels: true
  logins: true
  organizations: 'all'
  organization_paid_account: true
  organization_fields: 'name,displayName,idEnterprise,products'
  organization_enterprise: true
  paid_account: true
  pluginData: true
  savedSearches: true
  missedTransferDate: true
  enterpriseToExplicitlyOwnBoards: true
  enterprises: true
  enterprise_filter: ['saml', 'member', 'member-unconfirmed', 'owned']
  enterprise_fields: 'name,displayName,isRealEnterprise,idAdmins'

organizationBoardsPage =
  boards: 'open'
  board_fields: boardFieldsInOrganization
  board_starCounts: 'organization'
  board_membershipCounts: 'active'
  fields: organizationBoardsFields
  paid_account: true
  enterprise: true
  memberships: 'active'
  members: 'all'
  tags: true,
  billableCollaboratorCount: true

memberQuickBoards =
  fields: 'idOrganizations'
  boards: 'open,starred'
  board_fields: boardFieldsMinimal
  boardStars: true
  organizations: 'all'
  organization_fields: 'idBoards'

quickBoardsSearch = (search) ->
  query: search
  modelTypes: 'boards'
  board_fields: boardFieldsMinimal
  partial: true

module.exports.boardFieldsMinimal = boardFieldsMinimal
module.exports.boardFieldsFull = boardFieldsFull
module.exports.boardFieldsMinimalSubscribed = boardFieldsMinimalSubscribed
module.exports.memberFields = memberFields
module.exports.memberFieldsAndPremOrgsAdmin = memberFieldsAndPremOrgsAdmin
module.exports.organizationFieldsMinimal = organizationFieldsMinimal
module.exports.organizationFieldsMinimalMemberships = organizationFieldsMinimalMemberships
module.exports.cardFieldsBulk = cardFieldsBulk
module.exports.boardFieldsInOrganization = boardFieldsInOrganization
module.exports.organizationBoardsFields = organizationBoardsFields
module.exports.cardActions = cardActions
module.exports.boardActions = boardActions
module.exports.card = card
module.exports.currentBoardMinimal = currentBoardMinimal
module.exports.currentBoardSecondary = currentBoardSecondary
module.exports.currentBoardPluginData = currentBoardPluginData
module.exports.memberBoards = memberBoards
module.exports.memberHeader = memberHeader
module.exports.organizationBoardsPage = organizationBoardsPage
module.exports.memberQuickBoards = memberQuickBoards
module.exports.quickBoardsSearch = quickBoardsSearch
